import React from 'react';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';
import FusionCharts from 'fusioncharts';
import 'fusioncharts/fusioncharts.charts';

import { FormAPI } from 'lecom-api';
import { FormEvents, FormElements, FormEventHandler } from '../../form/events/form_event_handler';
import { ChartActions, ChartStore } from '../reflux/chart_store';
import ChartStoreItem from '../models/chart_store_item';

import { serializePrivateProperties } from '../../utils/object_utils';
import { parseDataSourceFromXMLPath, parseFusionChartsTypeFromChartType } from '../helpers/chart_data_helpers';

@mixin.decorate(Reflux.listenTo(ChartStore, 'onChartStoreLoad'))
export default class InputChart extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		name: PropTypes.string,
		label: PropTypes.string
	};

	static defaultProps = {
		id: '',
		name: '',
		label: Realize.i18n.t('template.defaultLabel'),
	};

	state = {
		store: new ChartStoreItem()
	};

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		ChartActions.init(this.props.id, this.props);
	}

	onChartStoreLoad(store) {
		this.setState({
			store: store[this.props.id]
		}, () => {
			if(!!this.chartLoaded){

				this.loadChart();
				this.tabIndex();
			}
		});
	}

	tabIndex() {
		let chart = $('.chart-field__wrapper');
		let chartLink = $('#graphic-link');

		if(chartLink.length > 0){
			chart.keypress((e) => {
				if(e.which === 13 ){
					let spanClick = $('#graphic-link span');
					spanClick.click();
				}
			})
		}
	}

	get store() {
		return this.state.store;
	}

	get chartLoaded() {
		return this.store.chartLoaded;
	}

	get chartData() {
		return this.store.chartData;
	}

	get chartContainerId() {
		return `chart-container-${this.props.id}`;
	}

	loadChart() {
		this.chartData.width = '100%';

		new FusionCharts(Object.assign({}, serializePrivateProperties(this.chartData), {
			renderAt: this.chartContainerId,
			dataSource: parseDataSourceFromXMLPath(this.props.name, this.chartData.xmlPath),
			type: parseFusionChartsTypeFromChartType(this.chartData.type)
		})).render();

		FormEventHandler.publish(FormEvents.CHART_LOAD, FormElements.FIELD, this.props.name);
	}

	renderLoadedChart() {
		const isLinkToView = this.chartData._isLinkToView;

		if(isLinkToView !== true){
			return <div id={this.chartContainerId} aria-label={`${this.props.label}`}></div>
		} else {
			return (
				<div id="graphic-link">
					<a id="types-of-views" className="collapse" tabIndex="0" onClick={() => {
						$(`#${this.chartContainerId}`).toggle()
						let styleGraphic = $(`#${this.chartContainerId}`)[0].style[0];

						if(styleGraphic !== undefined){
							$(`.collapse-text-${this.chartContainerId}`).html(Realize.i18n.t("template.actions.showGraph"));
							$(`#icon-graphic-link-${this.chartContainerId}`).html('keyboard_arrow_down');
						}
						else {
							$(`.collapse-text-${this.chartContainerId}`).html(Realize.i18n.t("template.actions.hideChart"));
							$(`#icon-graphic-link-${this.chartContainerId}`).html('keyboard_arrow_up');
						}
					}}>
						<span id="text-type-graphic"  className={`collapse-text-${this.chartContainerId}`}>{Realize.i18n.t("template.actions.showGraph")}</span>
						<i className="material-icons" id={`icon-graphic-link-${this.chartContainerId}`} aria-hidden="true">keyboard_arrow_down</i>
					</a>
					<div id={this.chartContainerId} style={{display: 'none'}} tabIndex="0"></div>
				</div>
			);
		}
	}

	renderSpinner() {
		return <Spinner />;
	}

	chartClick(){
		const formAPI = FormAPI.form(this.props.formId);
		formAPI.fields(this.props.id).publish(FormEvents.CHART_ITEM_CLICK);
	}

	renderChart() {
		return !!this.chartLoaded
		? this.renderLoadedChart()
		: this.renderSpinner();
	}

	render() {
		const styleChart = {
			marginTop: "10px"
		};
		
		return (
			<div className="chart-field__wrapper" style={styleChart}  onClick={this.chartClick.bind(this)}>
				<div id={`helpText-${this.chartContainerId}`} className="hidden">{this.props.helpText}</div>
				{this.renderChart()}
			</div>
		);
	}

}
